import template from './commercial-material-type.jade';
import buildingMaterialType from './../../../enums/material-type-commercial';
import { isValidEnum } from '../../../utils';

export default angular
  .module('cian.addForm.commercialMaterialType', [])
  .directive('cianAfAboutBuildingCommercialMaterialType', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller() {
      this.materialTypes = buildingMaterialType;

      // удаляем невалидное значение, пришедшее из других категорий
      if (this.ad.building && !isValidEnum(this.materialTypes, this.ad.building.materialType)) {
        this.ad.building.materialType = undefined;
      }
    },
    controllerAs: 'commercialBuildingMaterialType',
    template,
  })).name;
